import Upper from "./features/Upper";
import {useModal} from "../../../../hooks";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import {useEffect, useState} from "react";
import {ordersCreateInit, ordersCreateSubjectInit} from "./state";
import {OrdersCreateSubjectType, OrdersCreateType} from "./interface";
import {useForm, useWatch} from "react-hook-form";
import TabNav from "./features/TabNav";
import Tab1 from "./features/Tab1";
import Tab2 from "./features/Tab2";
import {useUser} from "../../../../util/userContext/UserContext";
import {useCreateOrder} from "./hooks/useCreateOrder";
import {useReadPurchaseOrderDetail} from "../../../purchase/pcs/detail/hooks/useReadPurchaseOrderDetail";
import {useReadPurchaseOrderSubject} from "../../../purchase/pcs/detail/hooks/useReadPurchaseOrderSubject";
import {useSearchParams} from "react-router-dom";
import useSetOrdersValue from "./hooks/useSetOrdersValue";
import moment from "moment/moment";

export default function OrdersCreate() {
    const id = useSearchParams()[0].get("i")
    const {handleModal} = useModal();
    const {user} = useUser();
    const {goToNavigation} = useGoToNavigation();

    const [tab, setTab] = useState("tab-1");

    const {data: pcsDetail} = useReadPurchaseOrderDetail({param: {purchaseOrderId: Number(id as string)}})
    const {data: pcsSubject} = useReadPurchaseOrderSubject({param: {purchaseOrderId: Number(id as string)}})
    const {mutateAsync: mutateCreateOrder} = useCreateOrder()

    const now = moment().format("YYYY-MM-DD")
    const {register, getValues, setValue, control, handleSubmit, watch} = useForm({
        defaultValues: (() => ({
            ...ordersCreateInit,
            newDtOrder: now,
            newDtRequestShipment: now,
            newDtShipment: now,
        }))()
    })
    const {
        register: registerSubject,
        getValues: getValuesSubject,
        setValue: setValueSubject,
        control: controlSubject,
        handleSubmit: handleSubmitSubject,
        watch: watchSubject
    } = useForm({
        defaultValues: ordersCreateSubjectInit,
    })

    const watchCreateDetail = {
        ...ordersCreateInit,
        ...useWatch<OrdersCreateType>({control}),
    } as OrdersCreateType

    const watchCreateSubject = {
        ...ordersCreateSubjectInit,
        ...useWatch<OrdersCreateSubjectType>({control: controlSubject}),
    } as OrdersCreateSubjectType

    // 내부수정: 확인 로직 분리
    const saveOrder = () => {
        mutateCreateOrder({
            orderDetailRes: {
                ...watchCreateDetail,
                chargeId: user?.userId ?? 0,
                newDtRequestShipment: getValues("newDtRequestShipment")
            },
            orderSubjectResList: watchCreateSubject.list.map(el => ({
                ...el,
                new_d_total: el.new_i_qty * el.new_d_unitprice
            }))
        }).then(res => {
            if (String(res?.data?.code) === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "저장되었습니다.",
                    type: "alert",
                    closeAction: () => {
                        goToNavigation(`order/orders/list`, {}, false)
                    }
                });
            } else {
                // const msgData: any = res.data?.msg

                // handleModal({
                //     isOpen: true,
                //     contents: res.data.msg ?? msgData,
                //     type: "alert",
                // });
            }
        })
    }

    const btnSave = () => {
        if (!watchCreateDetail.newLEnduserValue || watchCreateDetail.newLEnduserValue === "") {
            handleModal({
                isOpen: true,
                contents: "고객사를 선택해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail.newLContactValue || watchCreateDetail.newLContactValue === "") {
            handleModal({
                isOpen: true,
                contents: "수주고객을 선택해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail.owneridValue || watchCreateDetail.owneridValue === "") {
            handleModal({
                isOpen: true,
                contents: "담당자를 선택해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail.newPShipment || watchCreateDetail.newPShipment === 0) {
            handleModal({
                isOpen: true,
                contents: "발송방법을 선택해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail._new_l_recipient_value || watchCreateDetail._new_l_recipient_value === "") {
            handleModal({
                isOpen: true,
                contents: "수신자를 선택해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail.newDtOrder || watchCreateDetail.newDtOrder === "") {
            handleModal({
                isOpen: true,
                contents: "수주일자를 입력해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail.newLShipToValue || watchCreateDetail.newLShipToValue === "") {
            handleModal({
                isOpen: true,
                contents: "납품처를 선택해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail.newLCustomerValue || watchCreateDetail.newLCustomerValue === "") {
            handleModal({
                isOpen: true,
                contents: "매출처를 선택해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail.newDtOrder || watchCreateDetail.newDtOrder === "") {
            handleModal({
                isOpen: true,
                contents: "수주일자를 입력해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail._new_l_order_type_m_value || watchCreateDetail._new_l_order_type_m_value === "") {
            handleModal({
                isOpen: true,
                contents: "수주 유형을 선택해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail._new_l_vat_value || watchCreateDetail._new_l_vat_value === "") {
            handleModal({
                isOpen: true,
                contents: "Vat 구분을 선택해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail.newLIndustryValue || watchCreateDetail.newLIndustryValue === "") {
            handleModal({
                isOpen: true,
                contents: "산업 구분을 선택해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail.newLApplicationValue || watchCreateDetail.newLApplicationValue === "") {
            handleModal({
                isOpen: true,
                contents: "Application을 선택해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail.newDtEstimatedCollection || watchCreateDetail.newDtEstimatedCollection === "") {
            handleModal({
                isOpen: true,
                contents: "수금예정일을 입력해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail.newPPayment || watchCreateDetail.newPPayment === 0) {
            handleModal({
                isOpen: true,
                contents: "결제방법을 선택해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail.newLInvoiceAgentValue || watchCreateDetail.newLInvoiceAgentValue === "") {
            handleModal({
                isOpen: true,
                contents: "계산서 담당자를 선택해주세요.",
                type: "alert",
            })
        } else if (watchCreateSubject.list.length === 0) {
            handleModal({
                isOpen: true,
                contents: "수주 품목을 추가해주세요.",
                type: "alert",
            })
        } else if (watchCreateSubject.list.some(el => el._new_l_erp_product_value === "")) {
            handleModal({
                isOpen: true,
                contents: "수주 품목을 선택해주세요.",
                type: "alert",
            })
        } else if (watchCreateSubject.list.some(el => el.new_p_currency === "")) {
            handleModal({
                isOpen: true,
                contents: "수주 품목의 환종을 선택해주세요.",
                type: "alert",
            })
        } else {
            // 내부수정: 수량 10,000개 초과 품목이 있으면 확인 팝업 표출 (수량/단가 입력 실수 방지)
            const overQtyList = watchCreateSubject.list.filter(el => el.new_i_qty > 10000)
            if (overQtyList.length > 0) {
                handleModal({
                    isOpen: true,
                    contents: `${overQtyList.length}건의 수량이 10,000개를 초과합니다. \n그대로 등록하시겠습니까?`,
                    type: "confirm",
                    callback: () => {
                        saveOrder()
                    }
                })
            } else {
                saveOrder()
            }
        }
    };

    const {setOrdersDetailInit, setOrdersSubjectInit} = useSetOrdersValue()
    useEffect(() => {
        if (pcsDetail) {
            setOrdersDetailInit(pcsDetail, setValue)
        }
    }, [pcsDetail]);

    useEffect(() => {
        if (pcsSubject) {
            setOrdersSubjectInit(pcsSubject, setValueSubject)
        }
    }, [pcsSubject]);

    return <>
        <Upper watchCreateDetail={watchCreateDetail}
               register={register}
               btnSave={btnSave}/>

        <TabNav tab={tab}
                setTab={setTab}/>

        {tab === "tab-1"
            ? <Tab1 watchCreateDetail={watchCreateDetail}
                    register={register}
                    setValue={setValue}
                    watch={watch}/>
            : <Tab2 watchCreateSubject={watchCreateSubject}
                    register={registerSubject}
                    getValues={getValuesSubject}
                    setValue={setValueSubject}
                    control={controlSubject}/>
        }
    </>
}